<template>
  <section class="log-system-index-container">
    <base-header
      v-bind="headers"
      v-on:handleCreate="handleHeaderCreate"
    />
    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="list.params"
      @handleSearch="handleSearchs"
      @handleBtnSearch='handleEventBtnSearch'
    ></search-header>
    <base-table
      v-bind="list"
      v-on:handleSelectionChange="handleSelectionChange"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
      v-on:handleDelete="handleTableDelete"
      v-on:handlePost="handleTablePost"
      v-on:handleCancel="handleTableCancel"
    >
    </base-table>
    <msg-dialog
      v-bind="msgDialog"
      v-on:handleConfirm="handleConfirmMsg"
      v-on:handleCancel="hideMsgDialog"
    />
  </section>
</template>
<script>
import baseHeader from '@/components/mixins/baseHeader'
import baseTable from '@/components/mixins/baseTable'
import msgDialog from '@/components/mixins/msgDialog'
import searchHeader from '@/components/mixins/searchHeader'

const columns = [
  {
    prop: 'title',
    label: '稿件名称'
  },
  {
    prop: 'createUser',
    label: '投稿人'
  },
  {
    prop: 'status',
    label: '状态',
    formatter: (row, column, cellValue, index) => {
      const options = [
        {
          label: '草稿',
          value: 'DRAFT'
        },
        {
          label: '待审核',
          value: 'UNCHECK'
        },
        {
          label: '审核中',
          value: 'CHECKING'
        },
        {
          label: '已撤稿',
          value: 'CANCEL'
        },
        {
          label: '已返修',
          value: 'REFUND'
        },
        {
          label: '已录用',
          value: 'SUCCESS'
        },
        {
          label: '退稿',
          value: 'CANCELED'
        },
        {
          label: '退稿',
          value: 'SYSTEM_CANCELED'
        },
        {
          label: '申请撤稿',
          value: 'CHECK_CANCEL'
        },
        {
          label: '审核中',
          value: 'CHECKING_PROFESSOR'
        }
      ]
      const opt = options.find(d => d.value === cellValue)
      return opt ? opt.label : ''
    }
  },
  {
    scopeType: 'time',
    prop: 'createTime',
    label: '创建时间',
    minWidth: '150px'
  }
]
export default {
  name: 'listIndex',
  mixins: [baseHeader, baseTable, searchHeader, msgDialog],
  data () {
    return {
      searchHeader: {
        searchItems: [
          {
            type: 'input',
            value: 'queryTitle',
            label: '标题：',
            placeholder: '请输入标题',
            style: {
              width: '220px'
            }
          },
          {
            type: 'timePicker',
            value: 'time',
            label: '创建时间：',
            rangeText: '-'
          },
          {
            btnType: 'Search',
            type: 'henderBorderBtn',
            text: '搜索',
            icon: 'xiazai15'
          }
        ]
      },
      list: {
        columns,
        api: 'fetchUserCenterContentPage',
        params: {
          queryTitle: ''
        },
        handleColumn: [
          {
            type: 'Link',
            name: '编辑',
            icon: 'bianji',
            href: '/userCenter/content/edit'
          },
          {
            type: 'Post',
            name: '投稿',
            icon: 'fabu'
          },
          {
            type: 'Cancel',
            name: '撤稿',
            icon: 'chehui'
          },
          {
            type: 'Link',
            name: '查看',
            icon: 'chakan',
            notDisabled: true,
            href: '/userCenter/content/detail'
          },
          {
            type: 'Delete',
            name: '删除',
            icon: 'delete'
          }
        ],
        handleColumnProp: {
          label: '操作',
          width: '300',
          align: 'left'
        },
        showSelection: false
      },
      headers: {
        buttons: [
          {
            type: 'Create',
            text: '新建',
            icon: 'xinjian'
          }
        ],
        title: '',
        showAlertIcon: false,
        content: ''
      }
    }
  },
  components: {
  },
  methods: {
    // 搜索
    handleSearchs () {
      var params = this.list.params
      if (params.time) {
        params.queryCreateTimeStart = params.time[0]
        params.queryCreateTimeEnd = params.time[1]
      } else {
        params.queryCreateTimeStart = ''
        params.queryCreateTimeEnd = ''
      }
      this.list.params = params
      this.fetchTableApi()
    },
    handleEventBtnSearch () {
      this.handleSearchs()
    },
    // 顶部操作按钮
    handleHeaderCreate () {
      this.$routerLink('/userCenter/content/add')
    },
    // 表格操作按钮
    handleTableDelete (row, index) {
      this.msgDialog.type = 'DeleteOne'
      this.msgDialog.content = '是否确定删除？'
      this.msgDialog.data = row.id
      this.showMsgDialog()
    },
    handleTablePost (row, index) {
      this.msgDialog.type = 'Post'
      this.msgDialog.content = '是否确定投稿？'
      this.msgDialog.data = row.id
      this.showMsgDialog()
    },
    handleTableCancel (row, index) {
      // this.msgDialog.type = 'Cancel'
      // this.msgDialog.content = '是否确定撤稿？'
      // this.msgDialog.data = row.id
      // this.showMsgDialog()
      this.$prompt('请输入撤稿理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'promptStyle'
      }).then(({ value }) => {
        // this.$message({
        //   type: 'success',
        //   message: '申请成功'
        // });
        this.fetchUserCenterContentCancel(row.id, value)
      }).catch(() => {})
    },
    // 弹出框操作按钮
    handleConfirmMsg (type) {
      switch (type) {
        case 'DeleteOne':
          this.fetchUserCenterContentDelete(this.msgDialog.data)
          break
        case 'Post':
          this.fetchUserCenterContentPost(this.msgDialog.data)
          break
        // case 'Cancel':
        //   this.fetchUserCenterContentCancel(this.msgDialog.data)
        //   break
      }
    },
    fetchUserCenterContentDelete (id) {
      this.list.loading = true
      var params = {
        id: id
      }
      this.$request.fetchUserCenterContentDelete(params).then(res => {
        if (res.code === 200) {
          this.fetchTableApi()
        } else if (res.code === 14023) {}
        this.hideMsgDialog()
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    },
    fetchUserCenterContentPost (id) {
      this.list.loading = true
      var params = {
        id: id
      }
      this.$request.fetchUserCenterContentPost(params).then(res => {
        if (res.code === 200) {
          this.fetchTableApi()
        } else if (res.code === 14023) {}
        this.hideMsgDialog()
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    },
    fetchUserCenterContentCancel (id, value) {
      this.list.loading = true
      var params = {
        id: id,
        remark: value
      }
      this.$request.fetchUserCenterContentCancel(params).then(res => {
        if (res.code === 200) {
          this.fetchTableApi()
        } else if (res.code === 14023) {}
        // this.hideMsgDialog()
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    },
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content.map((d, i) => {
          d.disabledLink = !(d.status === 'DRAFT' || d.status === 'REFUND')
          d.disabledPost = !(d.status === 'DRAFT' || d.status === 'REFUND')
          d.disabledCancel = !(d.status === 'UNCHECK' || d.status === 'CHECKING' || d.status === 'SUCCESS' || d.status === 'CHECKING_PROFESSOR' || d.status === 'REFUND')
          d.disabledDelete = !(d.status === 'DRAFT' || d.status === 'CANCEL' || d.status === 'CANCELED' || d.status === 'SYSTEM_CANCELED')
          return d
        })
        this.list.totalCount = res.data.totalElements
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
